<div [formGroup]="parentFormGroup" class="form-container">
  <mat-form-field appearance="outline">
    <mat-label i18n>Price</mat-label>
    <input matInput id="pricing-price" type="number" formControlName="price">
  </mat-form-field>
</div>
